/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateInventoryRequestDto } from '../models/CreateInventoryRequestDto';
import type { ResolveInventoryRequestDto } from '../models/ResolveInventoryRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InventoryRequestsService {
  /**
   * Create an inventory request (SOL)
   * @param requestBody
   * @returns any Request created successfully
   * @throws ApiError
   */
  public static inventoryRequestsControllerCreate(
    requestBody: CreateInventoryRequestDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/inventory-requests',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * List inventory requests
   * @param page
   * @param limit
   * @param requestCode
   * @param status
   * @param sourceLocationId
   * @param destinationLocationId
   * @param dateFrom
   * @param dateTo
   * @returns any
   * @throws ApiError
   */
  public static inventoryRequestsControllerFindAll(
    page: number = 1,
    limit: number = 10,
    requestCode?: string,
    status?: 'PENDING' | 'APPROVED' | 'REJECTED',
    sourceLocationId?: number,
    destinationLocationId?: number,
    dateFrom?: string,
    dateTo?: string,
    sortBy?:
      | 'requestCode'
      | 'sourceLocationName'
      | 'destinationLocationName'
      | 'createdByName'
      | 'createdAt'
      | 'itemCount'
      | 'status',
    sortOrder?: 'ASC' | 'DESC',
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-requests',
      query: {
        page: page,
        limit: limit,
        requestCode: requestCode,
        status: status,
        sourceLocationId: sourceLocationId,
        destinationLocationId: destinationLocationId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    });
  }
  /**
   * Get inventory requests status summary metrics
   * @returns any
   * @throws ApiError
   */
  public static inventoryRequestsControllerGetMetricsSummary(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-requests/metrics/summary',
    });
  }
  /**
   * Get inventory request by ID
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static inventoryRequestsControllerFindOne(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-requests/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Get warehouse inventory product detail in request context (same payload as warehouse GET by id)
   * Requires request view/approve permissions only (intentional): verifies the product belongs to the request and the user can view that request (source or destination). Does not apply warehouse location VIEW_ROW so destination staff can inspect remote pieces on a SOL.
   * @param id Request ID
   * @param wipId Warehouse inventory product ID
   * @returns any Warehouse inventory product found
   * @throws ApiError
   */
  public static inventoryRequestsControllerFindWarehouseInventoryProductForRequest(
    id: number,
    wipId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-requests/{id}/warehouse-inventory-products/{wipId}',
      path: {
        id: id,
        wipId: wipId,
      },
      errors: {
        404: `Request or product not found, or product not in request`,
      },
    });
  }
  /**
   * Approve or reject request items and close the request
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static inventoryRequestsControllerResolve(
    id: number,
    requestBody: ResolveInventoryRequestDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/inventory-requests/{id}/resolve',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
